import { Component as BaseComponent, h } from 'preact';
import { connect } from 'preact-redux';
import { smoothScrollToElement } from '../scroll';

class Component extends BaseComponent {
    constructor(props) {
        super(props);

        const attrs = {...props}; // html attributes, without any weird routeTo etc
        delete attrs.children;
        delete attrs.innerHTML;
        delete attrs.routeTo;

        this.setState({ attrs });
    }

    render({ innerHTML }, { attrs }) {
        return (
            <a
              {...attrs}
              dangerouslySetInnerHTML={{__html: innerHTML || ''}}
              onClick={this.click}
            />
        );
    }

    click = (e) => {
        const el = document.querySelector(this.state.attrs.href);

        if (el) {
            e.preventDefault();
            e.stopPropagation();

            smoothScrollToElement(el);

            this.props.routeTo(this.state.attrs.href.replace(/^#/, ''));

            return false;
        }

        return true;
    }
}

const mapDispatchToProps = (dispatch) => ({
    routeTo: (hash) => dispatch({ type: 'route:to', payload: hash }),
});

export default connect(null, mapDispatchToProps)(Component);



// WEBPACK FOOTER //
// ./app/components/smooth-scroll.js